import { token } from '@atlaskit/tokens';

export const TODO_SEGMENT_COLOR_HIGHER_CONTRAST = token('color.chart.neutral');

export const IN_PROGRESS_SEGMENT_COLOR_HIGHER_CONTRAST = token('color.border.information');
export const DONE_SEGMENT_COLOR = token('color.border.success');
